import { Box, Collapse, Typography } from "@material-ui/core";
import styled from "styled-components";

export const CollapseHeader = styled.div`
    padding: 12px 24px;
    display: flex;
    justify-content: space-between;
    border: 1px solid #E2E2E2;
    background-color:  ${(props) => props.open ? '#F9F9F9' : '#FFFFFF'};
    border-radius: ${(props) => props.open ? '8px 8px 0 0' : '8px'};
    transition: all .3s ease-out;
`;

export const CollapseHeaderInfo = styled(Box)`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    padding-right: 12px;
`

export const CollapseBody = styled(Collapse)`
    position: relative;
    border: 1px solid #E2E2E2;
    border-top: none;
    border-radius: 0 0 8px 8px;
`

export const Ball = styled.div`
    width: 10px;
    height: 10px;
    background-color: ${props => props.theme.colors.textBold};
    border-radius: 50%;
    margin-bottom: 8px;
`
export const Line = styled.div`
    width: ${props => props.width};
    height: 2px;
    background-color: ${props => props.theme.colors.textBold};
    position: absolute;
    top: 16px;
    left: 0;
    right: 0;
    margin: auto;
`

export const DeliveryImage = styled.img`
    width: 36px;
    height: 36px;
    border-radius: 8px;
    margin-right: 6px;
    border: 1px solid #E2E2E2;
`
export const DeliveryTypography = styled(Typography)`
    font-size: 10px !important;
    font-weight: bold;
    color: ${props => props.theme.colors.primary};
    cursor: pointer;
`
